/* eslint-disable jsx-a11y/img-redundant-alt */
import { Row, Table, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { pupSelector, spamSelector } from "../../../services/selector/index.";
import {
  IconDownload,
  IconLoadEdit,
  IconLock,
  IconNext,
  IconPre,
  IconXmark,
} from "../../../assets/icon";
import "../../../assets/style/table/survey.scss";
import { useEffect, useState } from "react";
import { useMemo } from "react";
import { setOpenPUDelete } from "../../../services/slice/PopUpSlice";
import TranslateText from "../TranslateText";
import { setPageProduct } from "../../../services/slice/StoreSlice";
import { useTranslation } from "react-i18next";

import ModalDelete from "../Modal/delete/ModalDelete";
import moment from "moment";
import {
  deleteFileSpam,
  getLogFileSpam,
} from "../../../services/slice/SpamSlice";

const TblListSpam = () => {
  const dispatch = useDispatch();
  const statePup = useSelector(pupSelector);
  const spamState = useSelector(spamSelector);
  const { dataDelete } = statePup;
  //   const { config, data, total, callBackRequest } = surveyState;
  const [page, setPage] = useState();
  const [isDeleteTbl, setIsDeleteTbl] = useState(false);
  const [dataTBL, setDataTBL] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    setDataTBL(spamState.listFileSpam.data);
  }, [spamState?.listFileSpam?.data]);

  const dataSource = useMemo(() => {
    const result = dataTBL?.map((item, index) => {
      return {
        ...item,
        object: item.typeSurvey === 1 ? "Toàn bộ KH" : "CCS",

        STT:
          spamState.listFileSpam?.total > 10 && page >= 2
            ? (page - 1) * 10 + index + 1
            : index + 1,
        key: item.id,
      };
    });
    return result;
  }, [dataTBL, spamState.listFileSpam?.total, page]);
  const rowClassName = (record) => {
    return record.typeSurvey === 2 ? "marked-row" : "";
  };

  const handleShowModalDelete = (value) => {
    setIsDeleteTbl(true);
    dispatch(
      setOpenPUDelete({
        stateOpen: true,
        content: spamState.listTypeSpam.find((item) => item.type === value.type)
          ?.typeName,
        id: value.guid,
      })
    );
  };

  const handleShowEditModal = (value) => {
    // dispatch(setOpenEditSurvey({ isOpen: true, id: value.id }));
  };

  const columns = [
    {
      title: "STT",
      dataIndex: "STT",
      key: "STT",
      className: "centerCell",
      width: 70,
    },

    {
      title: <TranslateText text="Tên file spam" />,
      dataIndex: "type",
      key: "type",
      className: "title pointer centerCell",
      width: 600,
      ellipsis: {
        showTitle: false,
      },
      render: (value) => {
        return (
          <span>
            {
              spamState.listTypeSpam.find((item) => item.type === value)
                ?.typeName
            }
          </span>
        );
      },
    },
    {
      title: (
        <div className="statusProduct">
          <p className="textStatus">
            <TranslateText text="Thời gian cập nhật cuối" />
          </p>
        </div>
      ),
      dataIndex: "createTime",
      key: "createTime",
      className: "centerCell",
      render: (text, record) => (
        <span>{moment(text).format("DD/MM/YYYY HH:MM")}</span>
      ),
    },

    {
      title: <TranslateText text="Chức năng" />,
      key: "action",
      dataIndex: "action",
      className: "centerCell m10",
      render: (text, record) => {
        return (
          <div
            className="centerCell flex justify-center w-full "
            style={{ minWidth: "120px" }}
          >
            <span
              className="pointer iconTbl "
              style={{ marginRight: "3rem" }}
              //   onClick={() => dispatch(getLogProduct(record.id))}
            >
              <Tooltip title="Tải file xuống">
                <a
                  href={`${window.SERVER_URL}${record.urlDownload}`}
                  download={`${record.fileName}`}
                >
                  <IconDownload fill="rgba(50, 176, 50, 1)" />
                </a>
              </Tooltip>
            </span>
            <span
              className="pointer iconTbl"
              onClick={() => handleShowEditModal(record)}
              style={{ marginRight: "3rem" }}
            >
              <Tooltip title="Chỉnh sửa">
                <IconLoadEdit />
              </Tooltip>
            </span>
            <span
              className="pointer iconTbl "
              onClick={() => dispatch(getLogFileSpam(record.guid))}
              style={{ marginRight: "3rem" }}
            >
              <Tooltip title="Xem log">
                <IconLock />
              </Tooltip>
            </span>

            {record.typeSurvey === 2 ? null : (
              <span
                className="pointer iconTbl"
                onClick={() => handleShowModalDelete(record)}
              >
                <Tooltip title="Xóa">
                  <IconXmark />
                </Tooltip>
              </span>
            )}
          </div>
        );
      },
    },
  ];
  // const tableLoading = {
  //   spinning: storeState.isLoading, // isLoading là biến boolean để xác định xem có đang loading hay không
  //   indicator: <IconSpin className="iconSpin" />,
  // };

  const handleDelete = () => {
    dispatch(deleteFileSpam(dataDelete.id));
    setIsDeleteTbl(false);
    dispatch(setOpenPUDelete({ stateOpen: false, id: "", content: "" }));
  };
  return (
    <>
      {dataDelete.isOpenPUDelete && isDeleteTbl ? (
        <ModalDelete
          handleDelete={handleDelete}
          textDisable="Bạn đồng ý xóa file spam"
          title="Bkav Pro"
          width={680}
        />
      ) : null}
      <Row style={{ width: "100%" }}>
        <Table
          rowClassName={rowClassName}
          //   loading={tableLoading}
          className="wrapperTblSurvey"
          style={{ width: "100%", marginTop: "2.6rem" }}
          columns={columns}
          dataSource={dataSource}
          pagination={
            spamState.listFileSpam?.total > 10
              ? {
                  onChange: (value) => {
                    setPage(value);
                    dispatch(setPageProduct(value));
                  },
                  total: spamState.listFileSpam?.total,
                  pageSize: 10,
                  //   current: config.option.offset,
                  prevIcon: <IconPre />,
                  nextIcon: <IconNext />,
                  showSizeChanger: false,
                }
              : false
          }
        />
      </Row>
    </>
  );
};

export default TblListSpam;
